import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { take, compact } from 'lodash-es';
import InfiniteScroll from 'react-infinite-scroll-component';

import AppIcon from '../AppIcon';
import StoreIcon from '../StoreIcon';
import axios from '../../configs/axios';
import LoadingSpinner from '../LoadingSpinner';

const offset = 10;

class AppsList extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    scrollableTarget: PropTypes.string,
    active: PropTypes.object,
  };

  state = {
    itemsCount: this.props.data.length,
    hasMore: this.props.active ? this.props.active.total_apps_count > this.props.data.length : true,
    data: this.props.data,
  }

  fetchParams = () => {
    const { active } = this.props;
    const { itemsCount } = this.state;

    return {
      breadcrumbs: {
        limit: 10,
        offset: itemsCount,
        endpoint: active.kind,
        ref_no: active.ref_no,
        ...(active.kind === 'publisher' && { store: active.store }),
      },
    };
  }

  fetchData = () => {
    const { active } = this.props;
    const { data } = this.state;
    if (active && active.kind) {
      axios.get('/breadcrumbs/load_more.json', { params: this.fetchParams() })
        .then(({ data: nextPage }) => {
          if (nextPage.length) {
            const newData = [...data, ...nextPage];
            this.setState({
              data: newData,
              itemsCount: newData.length,
              hasMore: active.total_apps_count > newData.length,
            });
          } else {
            this.setState({ hasMore: false });
          }
        });
    } else {
      this.setState(prevState => ({
        itemsCount: prevState.itemsCount + offset,
        hasMore: this.props.data.length > prevState.itemsCount,
      }));
    }
  };

  renderList = () => {
    const { active } = this.props;
    const { itemsCount, data } = this.state;
    if (!data) return null;

    let dataMap;
    if (active && active.kind) {
      dataMap = data;
    } else {
      dataMap = compact(take(data, itemsCount));
    }
    return dataMap.map(item => (
      <li
        key={item.store + item.publisher_id + item.ref_no}
        className="text-truncate pos-rel"
      >
        <a href={item.url} className="text-truncate">
          <div className="d-flex align-items-items applications-list justify-content-center pl-xxs mr-xxs store-container text-xxxs">
            <StoreIcon store={item.store} />
          </div>
          {item.icon && <AppIcon store={item.store} url={item.icon} size={22} withBorder />}
          <span className="ml-xs text-truncate">{ item.name }</span>
        </a>
      </li>
    ));
  };

  render() {
    const { scrollableTarget } = this.props;
    const { itemsCount, hasMore } = this.state;
    return (
      <ul className="items applications-list">
        <InfiniteScroll
          dataLength={itemsCount}
          next={this.fetchData}
          hasMore={hasMore}
          style={{ overflow: 'visible' }}
          scrollableTarget={scrollableTarget}
          scrollThreshold={0.95}
          loader={<LoadingSpinner className="loader" />}
        >
          {this.renderList()}
        </InfiniteScroll>
      </ul>
    );
  }
}

export default AppsList;
